import {Message} from "semantic-ui-react";
import React from "react";

export const SuccessMessage = (props) => (
    <Message positive>
        <Message.Header>{props.header}</Message.Header>
        <p>{props.message}</p>
    </Message>
);